/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccordianContent } from '../../models/accordian-content';

export interface ApiMasterAccordianContentGetActiveGet$Params {
}

export function apiMasterAccordianContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterAccordianContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccordianContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterAccordianContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccordianContent>>;
    })
  );
}

apiMasterAccordianContentGetActiveGet.PATH = '/api/Master/AccordianContent/GetActive';
